import { useStyles } from "./styles";

interface IProps {
  baseColor?: string;
  Logo: FC;
  onClick: () => void;
  text: string;
}

export const BaseLoginButton: FC<IProps> = ({ baseColor = "var(--background)", Logo, onClick, text }) => {
  const classes = useStyles({ baseColor });

  return (
    <button className={classes.button} name="loginButton" onClick={onClick}>
      <div className={classes.logoContainer}><Logo className={classes.logo} /></div>
      <div className={classes.text}>{text}</div>
    </button>
  );
};
